import getSuitCSSClasses from '@/utils/getSuitCSSClasses';

export const classNames = {
  root: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-root',
  }),
  headerSection: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-header',
  }),
  paragraph: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-paragraph',
  }),
  listSection: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-list',
  }),
  imageContainer: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-image-container',
  }),
  titleAndPrice: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-title-and-price',
  }),
  textLink: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-all-items-link',
  }),
  item: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-item',
  }),
  itemTitle: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-item-title',
  }),
  itemPrice: getSuitCSSClasses({
    namespace: 'hz',
    name: 'Listing-other-seller-item-price',
  }),
};
